import React from "react";

/**
 * A filter label with an info icon that reveals a plain-language explanation
 * on hover (desktop) or focus/tap (mobile). Pure Tailwind, no dependencies.
 */
const FilterLabel = ({ label, hint }) => (
    <div className="flex items-center gap-1.5">
        <label className="text-[12px] font-semibold text-slate-500">{label}</label>
        <span
            tabIndex={0}
            role="button"
            aria-label={`${label}: ${hint}`}
            className="relative group inline-flex items-center text-slate-300 hover:text-[var(--color-2)] focus:text-[var(--color-2)] outline-none cursor-help"
        >
            <i className="fa-solid fa-circle-info text-[12px]" />
            <span
                role="tooltip"
                className="pointer-events-none absolute left-0 bottom-full mb-2 w-56 rounded-lg bg-slate-800 text-white text-[11px] font-normal leading-snug p-2.5 text-left normal-case opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus:opacity-100 group-focus:visible transition-opacity duration-150 z-[300] shadow-xl"
            >
                {hint}
                <span className="absolute left-2 top-full -translate-y-1/2 w-2 h-2 rotate-45 bg-slate-800" />
            </span>
        </span>
    </div>
);

export default FilterLabel;
